import InputMask from 'react-input-mask';
import { Input } from '../Input';
import { Props } from './interfaces';
import withField from '~hocs/withField';

/*
 * `react-input-mask` remove `disabled` dos props que entrega à função de
 * children (ele o trata como prop controlada) e não o reaplica ao elemento.
 * Sem repassá-lo aqui o campo só perde os handlers: continua sem `disabled`
 * no DOM, focável e sem sinal para leitor de tela.
 */
export const MaskedInput = ({ onKeyDown, ...props }: Props) => {
  return (
    <InputMask {...props} maskChar={null}>
      {(inputProps) => (
        <Input
          {...inputProps}
          disabled={props.disabled}
          onKeyDown={onKeyDown}
        />
      )}
    </InputMask>
  );
};

export default withField(MaskedInput);
